<template>
  <v-col cols="12">
    <base-card>
      <v-card-title>
        Generador de informe de documentos NO procesados
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col
              cols="12"
            >
              El informe solo podrá generarse dentro de un rango de 90 días.
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-can="'Selector Compañias'"
              cols="12"
              sm="4"
            >
              <v-select
                ref="cliente"
                v-model="processedDocsData.IdCompania"
                :items="filteredClients"
                item-text="text"
                item-value="IdCompania"
                label="Selecciona una compañía (opcional)"
                prepend-inner-icon="mdi-sitemap"
                clearable
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          v-model="search"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                          dense
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-dialog
                ref="dialog"
                v-model="modal"
                persistent
                width="300px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="processedDocsData.dateRange"
                    label="Rango de fechas"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    required
                    :error = dateRangeError
                    :error-messages = "dateRangeErrorMessage"
                    :rules="[
                  v => !!v || 'Este campo es obligatorio'
                ]"
                  />
                </template>

                <v-date-picker
                  v-model="processedDocsData.dateRange"
                  range
                  :min="minDate"
                  :max="maxDate"
                  :disabled-dates="disabledDates"
                  locale="es"
                  @input="onDateRangeInput"
                >
                  <v-spacer />
                  <v-btn
                    text
                    style="background-color: rgb(204 33 40); color: white !important"
                    @click="modal = false"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    style="background-color: rgb(204 33 40); color: white !important"
                    @click="onAccept"
                  >
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="processedDocsData.Status"
                :items="typeStatus"
                item-text="textStatus"
                item-value="valueStatus"
                label="Estado (opcional)"
                prepend-inner-icon="mdi-order-bool-descending-variant"
                clearable
              />
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                ref="Nit"
                v-model="processedDocsData.email"
                label="Correo"
                counter
                maxlength="80"
                prepend-inner-icon="mdi-email"
                required
                :rules="[
                v => !!v || 'Este campo es obligatorio',
                v => /.+@.+\..+/.test(v) || 'El correo no es válido'
              ]"
              />
            </v-col>

            <v-col cols="12" sm="4">
              <v-btn
                class="ma-2"
                :style="generateButtonStyle"
                @click="validateForm"
                :disabled = "generatingReport"
              >
                Generar
              </v-btn>

              <v-btn
                class="ma-2"
                color="GRAY"
                @click="clearForm"
                :disabled = "generatingReport"
              >
                Limpiar
              </v-btn>
            </v-col>

          </v-row>

          <v-row
            v-if="generatingReport"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Generando Informe
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
            >
              <v-alert
                v-show="successAlert"
                :type="alertType"
                text
              >
                {{ successAlertMsg }}
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </base-card>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { environment } from '@/data/environment'
import { listStatusUnprocessedFilters } from '@/data/listStatus'

export default {
  name: 'unprocessedDocsFilter',

  data () {
    return {
      modal: false,
      generatingReport: false,
      processedDocsData: {
        IdCompania: null,
        dateRange: [],
        Status: '',
        email: ''
      },
      dataUpdateFabricante: [],
      formHasErrors: null,
      dateRangeError: null,
      dateRangeErrorMessage: [],
      successAlertMsg: '',
      successAlert: false,
      alertType: 'success',
      detailClients: [],
      search: '',
      userInfo: null,
      isGeneralAdmin: false,
      typeStatus: listStatusUnprocessedFilters
    }
  },
  created () {
    this.getUserInfo()
    this.obtenerCompanias()
  },
  computed: {
    ...mapState('invoice', [
      'statusGenerateReportStatus', 'statusGenerateReportMessage'
    ]),
    filteredClients() {
      const query = (this.search || '').toLowerCase()
      return this.detailClients.filter(c =>
        c.text.toLowerCase().includes(query)
      )
    },
    minDate() {
      const today = new Date()
      const minDate = new Date(today)
      minDate.setDate(today.getDate() - 89)
      return minDate.toISOString().split('T')[0]
    },
    maxDate() {
      const today = new Date()
      return today.toISOString().split('T')[0]
    },
    disabledDates() {
      const minDate = this.minDate;
      return (date) => {
        const dateString = date.toISOString().split('T')[0];
        return dateString < minDate;
      };
    },
    setStatusResponseDownloadReportFile () {
      return this.$store.state.invoice.statusGenerateReportStatus
    },
    setStatusResponseDownloadReportFileMsg () {
      return this.$store.state.invoice.statusGenerateReportMessage
    },
    generateButtonStyle() {
      return {
        backgroundColor: this.generatingReport ? 'gray' : 'rgb(204 33 40)',
        color: this.generatingReport ? 'lightgray' : 'white',
      };
    },

  },
  watch:
    {
      formHasErrors () {
        if (this.formHasErrors === false) {
          this.generateReport()
        }
      },
      setStatusResponseDownloadReportFile () {
        if (this.setStatusResponseDownloadReportFile === true) {
          this.generatingReport = false
          this.generateAlertSuccess(this.setStatusResponseDownloadReportFileMsg)
          this.$store.dispatch('invoice/setStatusResponseDownloadReportFile', null)
        } else if (this.setStatusResponseDownloadReportFile === false) {
          this.generatingReport = false
          this.generateErrorAlert(this.setStatusResponseDownloadReportFileMsg)
          this.$store.dispatch('invoice/setStatusResponseDownloadReportFile', null)
        }
      },
    },
  methods: {
    generateAlertSuccess (msj) {
      this.alertType = 'success'
      this.successAlertMsg = msj
      this.successAlert = true
      setTimeout(() => {
        this.successAlertMsg = ''
        this.successAlert = false
        this.clearForm()
      }, 4000)
    },
    generateErrorAlert (msj) {
      this.alertType = 'error'
      this.successAlertMsg = msj
      this.successAlert = true
      setTimeout(() => {
        this.successAlertMsg = ''
        this.successAlert = false
      }, 4000)
    },
    clearForm() {
      // Guardar el IdCompania antes de resetear
      const permissions = JSON.parse(localStorage.getItem('permissions') || "[]")
      const hasCompanySelector = permissions.includes('Selector Compañias')
      const shouldPreserveIdCompania = this.isGeneralAdmin || !hasCompanySelector
      const savedIdCompania = shouldPreserveIdCompania ? this.processedDocsData.IdCompania : null

      this.$refs.form.reset()
      this.dateRangeError = null
      this.dateRangeErrorMessage = []
      this.formHasErrors = null
      this.successAlert = false

      // Restaurar el IdCompania
      if (shouldPreserveIdCompania && savedIdCompania) {
        this.processedDocsData.IdCompania = savedIdCompania
      }
    },
    validateForm() {
      // Validar rango de fechas
      if (!this.processedDocsData.dateRange || this.processedDocsData.dateRange.length === 0) {
        this.dateRangeError = true
        this.dateRangeErrorMessage = 'Este campo es obligatorio'
        return
      } else {
        this.dateRangeError = false
        this.dateRangeErrorMessage = []
      }

      // Validar formulario
      const isValid = this.$refs.form.validate()

      if (isValid && this.processedDocsData.dateRange[1] !== undefined) {
        this.generateReport()
      } else {
        this.generateErrorAlert('Por favor, complete todos los campos correctamente.')
      }
    },
    async generateReport() {
      this.generatingReport = true
      await this.$store.dispatch('invoice/generateUnprocessedInvoicesReport', {
        ...this.processedDocsData
      })
    },
    onDateRangeInput(dateRange) {
      if (dateRange && dateRange.length === 2) {
        const startDate = new Date(dateRange[0])
        const endDate = new Date(dateRange[1])
        const diffInDays = (endDate - startDate) / (1000 * 3600 * 24)

        if (diffInDays > 90) {
          this.processedDocsData.dateRange = [dateRange[0], this.addDays(new Date(dateRange[0]), 90)]
        }
      }
    },
    addDays(date, days) {
      const newDate = new Date(date)
      newDate.setDate(date.getDate() + days)
      return newDate.toISOString().split('T')[0]
    },
    onAccept() {
      this.modal = false
    },
    getUserInfo() {
      try {
        const uid = localStorage.getItem('uid')
        if (uid) {
          this.userInfo = JSON.parse(atob(uid))
          const rol = JSON.parse(localStorage.getItem('role') || "[]")
          const permissions = JSON.parse(localStorage.getItem('permissions') || "[]")

          this.isGeneralAdmin = rol.includes('General-Admin') || rol.includes('General')
          const hasCompanySelector = permissions.includes('Selector Compañias')

          // verificacion de rol
          if (this.isGeneralAdmin || !hasCompanySelector) {
            this.processedDocsData.IdCompania = this.userInfo.idcompania
          }
        }
      } catch (error) {
        console.error('Error al obtener información del usuario:', error)
      }
    },
    async obtenerCompanias() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || "[]")
      const hasCompanySelector = permissions.includes('Selector Compañias')

      if (this.isGeneralAdmin || !hasCompanySelector) {
        return
      }

      try {
        const response = await axios.get(environment.HIOPOSWEBSERVICES + '/getClientsForXML')

        let companies = response.data.Mensaje

        this.detailClients = companies.map(c => ({
          text: " [ " + c.id +  " ] " +  c.name,
          IdCompania: c.id,
        }))
      } catch (error) {
        console.error('Error al obtener compañías:', error)
      }
    },
  },
}
</script>